export default "__VITE_ASSET__CCSRD0g9__"